import { Switch,Route } from 'react-router-dom';
import { lazy } from 'react';
import { Loader } from '@src/components';
import ConfigSuspense from '../ConfigSuspense';
import ProtectedRoute from '../ProtectedRoutes';

const MainPlayer = lazy( () => import( '@src/components/Player/MainPlayer' ) );

const PlayerRoute=() => {
    return (
        <ConfigSuspense fallback={ <Loader /> }>
            <Switch>
                <Route  path='(.*)/watch/:id' component= { MainPlayer } />
            </Switch>
        </ConfigSuspense>
    )
}

export { PlayerRoute };